import(/* webpackMode: "eager" */ "/Users/martina/Desktop/Bigbang/web/app/error.tsx");
